import type { QueryKey } from "@tanstack/react-query";

/** Query-key factory for the staff Lead Generator feedback feed. Reads register
 *  under `leadGenFeedbackKeys.all` so a post covers every generator's list with
 *  ONE prefix invalidation (stale-after-save convention). */
export const leadGenFeedbackKeys = {
  all: ["lead-gen-feedback"] as const,
  list: (generatorId: string): QueryKey => [...leadGenFeedbackKeys.all, "list", generatorId],
};
